import React from 'react'
import { Link } from 'react-router'
import { Button, Input, Select } from '@driftt/tide-core-legacy'
import PlaybooksReportButton from '../PlaybooksReportButton'

import './style.styl'

const PlaybooksTableToolbar = ({
  onSelectedStatusChange,
  categoryCounts,
  selectedStatus,
  statusOptions,
  searchChange,
  showPrioritizeButton = false,
  pagination,
  searchString,
  playbooksListRequestPending,
  playbooks,
  activeTab
}) => {
  const newOptions = statusOptions.map(option => {
    const playbookCounts = categoryCounts.hasOwnProperty(option.value) ? categoryCounts[option.value] : '-'
    return {
      value: option.value,
      label: `${option.label} (${playbookCounts})`
    }
  })

  const shouldShowPlaybookCountEstimate = playbooks && searchString && !playbooksListRequestPending
  const totalPlaybookEstimate = Math.max(pagination.pageSize * (pagination.totalPages - 1), playbooks ? playbooks.length : 0)

  return (
    <header className="playbooks-table-toolbar">
      <span className="playbooks-table-toolbar-components-wrapper">
        <span className="playbooks-table-toolbar-span-left">
          <Select
            options={newOptions}
            className="playbooks-list-status-select"
            value={selectedStatus}
            onChange={onSelectedStatusChange}
            clearable={false}
          />
          { shouldShowPlaybookCountEstimate && <div className="playbook-table-toolbar-results-count">{`${totalPlaybookEstimate}+ results`}</div>}
        </span>
        <span>
          {activeTab !== 'SIGNATURE' && 
            <PlaybooksReportButton activeTab={activeTab} />
          }
          {showPrioritizeButton &&
            <Link to={`/playbooks/prioritize`}><Button type="secondary" className="playbooks-table-prioritize-button">Set Priority</Button></Link>
          }
          <Input className="playbooks-table-toolbar--search" type="search" placeholder="Search by name or ID" onChange={searchChange} />
        </span>
      </span>
    </header>
  )
}

export default PlaybooksTableToolbar



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksTableToolbar/index.js